import React, { useEffect } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const QRMenu = React.lazy(() => import("./views/pages/qr/QRMenu"));
const QRCalificacion = React.lazy(() =>
  import("./views/pages/qr/QRCalificacion")
);
const QRPromocion = React.lazy(() => import("./views/pages/qr/QRPromocion"));
const QRPagoPayPal = React.lazy(() => import("./views/pages/qr/QRPagoPayPal"));
const QRCarta = React.lazy(() => import("./views/pages/qr/QRCarta"));

const App = () => {
 

  return (
    <HashRouter>
      <React.Suspense fallback={loading}>
        <Switch>
          <Route
            exact
            path="/"
            name="Login"
            render={(props) => <Login {...props} />}
          />
          <Route
            exact
            path="/QRMenu/:clienteId"
            name="QRMenuPublic"
            render={(props) => <QRMenu {...props} />}
          />
          <Route
            exact
            path="/QRCalificacion/:clienteId"
            name="QRCalificacionPublic"
            render={(props) => <QRCalificacion {...props} />}
          />
          <Route
            exact
            path="/QRPromocion/:clienteId"
            name="QRPromocionPublic"
            render={(props) => <QRPromocion {...props} />}
          />
          <Route
            exact
            path="/QRPagoPayPal/:clienteId"
            name="QRPagoPayPalPublic"
            render={(props) => <QRPagoPayPal {...props} />}
          />
          <Route
            exact
            path="/QRCarta/:clienteId"
            name="QRCartaPublic"
            render={(props) => <QRCarta {...props} />}
          />
          <Route
            path="/app"
            name="App"
            render={(props) => <TheLayout {...props} />}
          />
        </Switch>
      </React.Suspense>
    </HashRouter>
  );
};

export default App;
